import React, { useCallback, useEffect } from 'react';
import { array, bool, func, shape } from 'prop-types';

import { groupBy } from 'lodash';

import useApi from '../../hooks/useApi';
import template from 'url-template';

import TagSelect from '../../components/FormFields/TagSelect';

const EquipmentTypesUrl = template.parse('/equipment-types{?limit}');
const LIMIT = 10000;

const EquipmentSelectFilter = ({
    disabled,
    equipmentFilter,
    onChangeEquipmentFilter,
    ...props
}) => {
    const [equipment, getEquipment] = useApi(() => ({
        url: EquipmentTypesUrl.expand({
            limit: LIMIT,
        })
    }));

    useEffect(() => {
        getEquipment();
        return () => {
            equipment.cancel();
        };
    }, []);

    const changeHandler = (defaultValues = {}) => {
        return (event) => {
            const { value } = event.target;
            const groupedValues = groupBy(value, 'type');
            const newValues = { ...defaultValues };
            Object.entries(groupedValues).forEach(([type, value]) => {
                newValues[type] = value;
            });
            onChangeEquipmentFilter(newValues);
        };
    };

    const handleChange = useCallback(
        changeHandler({
            equipment: []
        })
    );

    const options = [
        {
            error:     equipment.error,
            isLoading: equipment.loading,
            items:     equipment.data,
            name:      'Equipment',
            itemProps: {
                type: 'equipment'
            }
        }
    ];

    const value = [...equipmentFilter.equipment];

    return (
        <TagSelect
            disabled={disabled}
            grouped
            kickerText="Add any combination of Equipment Types to filter by these types."
            label="Equipment"
            name={undefined}
            onChange={handleChange}
            options={options}
            placeholder="Add Equipment Type"
            value={value}
            {...props}
        />
    );
};

EquipmentSelectFilter.defaultProps = {
    equipmentFilter: {
        equipment: []
    },
    disabled:                false,
    onChangeEquipmentFilter: () => {}
};

EquipmentSelectFilter.propTypes = {
    equipmentFilter: shape({
        equipment: array.isRequired
    }),
    disabled:                bool,
    onChangeEquipmentFilter: func.isRequired
};

export default EquipmentSelectFilter;
